import { RegisteredTo } from "@chq/enrollment-api";

export const useRegisteredToTypes = (): RegisteredTo[] => {
  return [RegisteredTo.Company, RegisteredTo.LeasingCompany, RegisteredTo.Other];
};
